const _getDateOrdinal = (day: number): string => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

const _formatDayWithOrdinal = (date: Date): string => {
  const day = date.getDate();
  return day + _getDateOrdinal(day);
};

export const formatMonthStrDayStr = (date: Date): string => {
  // ex: Mar 3rd
  const monthStr = date.toLocaleString('default', {
    month: 'short',
  });
  const dateStr = _formatDayWithOrdinal(date);
  return monthStr + ' ' + dateStr;
};
